import { graphql } from 'gatsby';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Pagination from 'components/Pagination';
import { SectionLayout } from 'components/Sections/SectionLayout';
import HeroWithProgressiveForm from 'components/Hero/HeroWithProgressiveForm';
import BlogCardGroupSection from 'components/ImageCardSections/BlogCardGroupSection';
import DemoFormSection from 'components/DemoFormSection';
import ToolboxLayout from 'layouts/toolboxLayout';

const BlogTemplate = props => {
  const filteredPosts = props.data.filteredPosts.edges.map(x => x.node);
  const allPosts = props.data.allPosts.edges.map(x => x.node);

  const hubType = 'blog';
  const seo = props.data.contentfulSeo;
  const [formValues, setFormValues] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    setFormValues({
      ...JSON.parse(localStorage.getItem('ProgressiveForm')),
    });
  }, []);

  const onSubmit = data => {
    localStorage.setItem('ProgressiveForm', JSON.stringify(data));
    setFormValues(data);
  };

  const breadcrumbs = {
    data: [
      {
        title: 'Toolbox',
        icon: null,
        url: '/toolbox',
      },
      {
        title: 'Blog',
        icon: null,
        url: props.pageContext.category === 'All' ? null : '/blog',
      },
    ],
  };

  if (props.pageContext.category !== 'All') {
    breadcrumbs.data.push({
      title: props.pageContext.category,
      icon: null,
      url: null,
    });
  }
  if (props.pageContext?.currentPage > 1 || props.pageContext.category) {
    seo.canonicalUrl = null;
  }

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={seo} {...props}>
      <BlogContent>
        <SectionLayout className="blog-content--layout" backgroundColor="white" contentBelowSection>
          <HeroWithProgressiveForm
            title="ServiceTitan blog."
            description="Get the knowledge and inspiration you need to run your home and commercial service business better."
            background="white"
            buttonBackground="#009DE6"
            revealProps={{
              styles: 'section-blog-details-legal-info',
              content: (
                <>
                  By entering your information above and clicking this button, you agree that we may
                  contact you at the phone number or email address you provide in this form. Our{' '}
                  <a href="/terms-of-use" target="_blank">
                    Terms of Use
                  </a>{' '}
                  and{' '}
                  <a href="/privacy-policy" target="_blank">
                    Privacy Policy
                  </a>{' '}
                  apply.
                </>
              ),
            }}
            formValues={formValues}
            onSubmit={onSubmit}
          />
          <BlogCardGroupSection
            content={filteredPosts}
            allContent={allPosts || filteredPosts}
            hubType={hubType}
            menuText="Category"
            category={props.pageContext.category}
            allCategory={props.pageContext.allCategory}
            onSearch={term => {
              setSearchTerm(term);
            }}
          />
          {props.pageContext.category === 'All' && !searchTerm && (
            <Pagination template={hubType} pageContext={props.pageContext} />
          )}
        </SectionLayout>
        <DemoFormSection
          backgroundColor="Bright Blue"
          formTitle="Let’s get started."
          description="Explore why 100,000+ contractors trust Service Titan to run their business."
          title="Book a personalized demo today."
          redirectUrl="thankyou"
        />
      </BlogContent>
    </ToolboxLayout>
  );
};

export default BlogTemplate;

export const pageQuery = graphql`
  query BlogTemplateQuery($posts: [String!], $allPosts: [String!]) {
    contentfulSeo(internalName: { eq: "Blog" }) {
      ...Seo
    }
    site {
      siteMetadata {
        title
      }
    }
    filteredPosts: allContentfulBlog(
      filter: { contentful_id: { in: $posts } }
      sort: { order: DESC, fields: publishDate }
    ) {
      edges {
        node {
          ...Blog
        }
      }
    }
    allPosts: allContentfulBlog(
      filter: { contentful_id: { in: $allPosts } }
      sort: { order: DESC, fields: publishDate }
    ) {
      edges {
        node {
          ...Blog
        }
      }
    }
  }
`;

const BlogContent = styled.div`
  font-family: Sofia Pro;

  .blog-content--layout .section-layout--inner-container {
    padding-top: 0;
  }

  .section-blog-details-legal-info {
    opacity: 1;
    width: 500px;
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
    margin: 0 auto -70px auto;
    color: var(--black-color);
  }

  .section-blog-details-submit-legal-info {
    opacity: 1;
    width: 500px;
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
    margin: 0 auto -70px auto;
    color: var(--green-5);
  }

  @media (max-width: 767px) {
    .section-blog-details-legal-info {
      width: 100%;
      margin: 0 auto -89px auto;
    }
  }
`;
